export default __webpack_public_path__ + "static/logo-2-ffde2b536c19d44777245c576144fa8d.jpeg";